module.exports = __webpack_public_path__ + "static/image/service/pc/connect.jpg?23b12e40";